var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteWhiteBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "memory_list",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18779",
    "data-name": "Gruppe 18779",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24192",
    "data-name": "Rechteck 24192",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283706",
    "data-name": "Pfad 283706",
    d: "M34.29,16.732l-.018-.016a6.06,6.06,0,0,0-8.617.015L25,17.394l-.656-.663a6.064,6.064,0,0,0-8.634,0,6.208,6.208,0,0,0,0,8.7L24.591,34.4a.575.575,0,0,0,.818,0l8.88-8.969A6.2,6.2,0,0,0,34.29,16.732Zm-.818,7.894L25,33.183l-8.473-8.557a5.054,5.054,0,0,1,0-7.087,4.893,4.893,0,0,1,3.5-1.464h0a4.893,4.893,0,0,1,3.5,1.465l1.064,1.075a.577.577,0,0,0,.41.165h0a.57.57,0,0,0,.406-.165l1.066-1.078a4.913,4.913,0,0,1,7,.006A5.051,5.051,0,0,1,33.472,24.626Z",
    transform: "translate(-13 -13)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteWhiteBorder);
export default __webpack_public_path__ + "static/media/favorite_white_border.4384a8237cc40c9caa49769657d33a90.svg";
export { ForwardRef as ReactComponent };